import React, { useState } from "react";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import HeaderProfileSection from "../homeDashboard/HeaderProfileSection";
import "../dashboard/Dashboard.css";
import LanguageIcon from "../assets/images/App-Language.png";

// Import SVG
import { BackSVG } from "../components/SvgIcons";

const ContentLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("english");

  const languages = [
    {
      id: "english",
      label: "English",
    },
    {
      id: "hindi",
      label: "हिंदी",
    },
  ];

  return (
    <>
      <style>{`
        .page-content {
          background: #fff;
        }

        body {
          background: #fff !important;
        }
    .re-bottom-bar {
      left: 300px;
      width: calc(100vw - 620px);
      bottom: 44px;
    }
        @media (max-width: 767px) {
          .headerDash {
            display: none;
          }

          .layout-wrapper .main-content {
            padding-top: 0px !important;
          }
        .re-bottom-bar {
          left: 0;
          width: 100%;
          bottom: 44px;
       }
        }

        
      `}</style>
       <HomeDashboardLayout showHeader={false}>
         <div className="qbankList-page page-padding">
          <div className="qbl-main">
            {/* <section className="qbl-panel"> */}
              {/* Page Header */}
              <div className="hideProfile-page">
                <div className="categories-page-header mb-0">
                  <div>
                    <button
                      type="button"
                      className="categories-back-button"
                      onClick={() => window.history.back()}
                      aria-label="Go back"
                    >
                      <i className="bi bi-chevron-left"></i>
                    </button>
                  </div>

                  <div></div>

                  <div>
                    <HeaderProfileSection />
                  </div>
                </div>
              </div>

        <div className="qb-wrapper content-language">

            {/* Page Title */}
            <div className="qb-body">
              <div className="d-flex align-items-center justify-content-center">
                <div className="qb-copy">
                  <h1 className="qb-title">
                    Content <span>Language</span>
                  </h1>
                  <p className="qb-sub qbb-list">
                      Select your preferred content language. This will determine the
                      language in which articles, videos, and other in-app content
                      are shown.
                  </p>
                </div>
               </div>
            </div>

          <div className="content-language__card">
            <div className="content-language__intro text-center">
              <div className="content-language__iconWrap d-flex align-items-center justify-content-center">
                <img
                  className="content-language__icon"
                  src={LanguageIcon}
                  alt="Content language"
                />
              </div>
            </div>

            <div
              className="content-language__options"
              aria-label="Content language"
            >
              {languages.map((language) => (
                <button
                  key={language.id}
                  type="button"
                  className={`content-language__option${
                    selectedLanguage === language.id
                      ? " content-language__option--active"
                      : ""
                  }`}
                  onClick={() => setSelectedLanguage(language.id)}
                  aria-pressed={selectedLanguage === language.id}
                >
                  {language.label}
                </button>
              ))}
            </div>
          <div className="re-bottom-bar" aria-label="Referral action">
               <button type="button" className="re-refer-btn text-capitalize"> 
                    Continue 
               </button>
            </div>
          </div>
        </div>
        </div>
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default ContentLanguage;

